import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useWalletStore } from '../store/useWalletStore';
import { useWebAuthn } from '../hooks/useWebAuthn';
import { beginTxLocal, verifyTxLocal } from '../services/local-api';

export function TransactionForm() {
  const { recordTx, setTxStatus, balance } = useWalletStore();
  const [to, setTo] = useState('address_abc');
  const [amount, setAmount] = useState(50);
  const [busy, setBusy] = useState(false);
  const { buildRequestOptions, getAssertion } = useWebAuthn();

  async function submit() {
    if (amount <= 0) return alert('Amount must be positive');
    if (amount > balance) return alert('Insufficient balance');
    setBusy(true);
    const txId = uuidv4();
    const tx = { id: txId, to, amount, nonce: crypto.getRandomValues(new Uint32Array(1))[0], timestamp: Date.now(), status: 'pending' as const };
    recordTx(tx);
    try {
      const txMsg = { txId, to, amount, nonce: tx.nonce, timestamp: tx.timestamp };
      const { challenge } = await beginTxLocal(txMsg);
      const opts = buildRequestOptions({ challenge });
      const assertion = await getAssertion(opts);
      await verifyTxLocal({ deviceId: assertion.id, response: assertion.response });
      setTxStatus(txId, 'approved');
    } catch (e) {
      setTxStatus(txId, 'rejected');
      alert((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="rounded border border-slate-800 p-4">
      <h3 className="font-medium">Send</h3>
      <div className="mt-3 grid gap-3 sm:grid-cols-3">
        <label className="block sm:col-span-2">
          <span className="text-sm text-slate-400">To address</span>
          <input value={to} onChange={e=>setTo(e.target.value)} className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-3 py-2" />
        </label>
        <label className="block">
          <span className="text-sm text-slate-400">Amount</span>
          <input type="number" value={amount} onChange={e=>setAmount(parseFloat(e.target.value))} className="mt-1 w-full rounded border border-slate-700 bg-slate-900 px-3 py-2" />
        </label>
      </div>
      <div className="mt-3">
        <button onClick={submit} disabled={busy} className="rounded bg-blue-600 px-4 py-2 hover:bg-blue-500 disabled:opacity-50">{busy ? 'Authorizing…' : 'Send'}</button>
      </div>
    </section>
  );
}


